import { gsap } from "gsap";

export default class Footer {
	constructor(elm) {
        this.elm = elm;

		this.init();
    }

    init() {
        this.resizeObserver = new ResizeObserver(entries => {
			this.setFooterHeight();
		});
		this.resizeObserver.observe(this.elm);
        this.setFooterHeight();
    }

    setFooterHeight() {
        const footerHeight = this.elm.getBoundingClientRect().height;

        gsap.set( document.documentElement, {
            "--footerHeight": (footerHeight * -1)+'px'
        });
    }

    destroy() {
        this.resizeObserver.disconnect();
    }

}